import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BbTableService, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';

import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'channel-list',
	templateUrl: './channel-list.component.html',
	styleUrls: ['./channel-list.component.scss'],
	providers: [BbTableService]
})

export class ChannelListComponent extends AbstractListComponent implements OnInit, OnDestroy {
	subscriptions = new Subscription();
	cloningRight: boolean;
	putRight: boolean;
	filterConfig: BbFilterConfiguration;
	entitiesToClone: any[];

	constructor(protected bbTableService: BbTableService) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'channel',
			basePath: '/library/channel',
			activePath: '/library/channels',
			entityTranslation: this.translate.instant('CHANNEL').toLowerCase(),
			entitiesTranslation: this.translate.instant('CHANNELS').toLowerCase()
		};
		// the presets are not being used yet in the html template
		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('PUBLISHED'),
				value: 'published',
				filterSet: [{
					filters: [{
						type: 'channel',
						field: 'status',
						operator: 'is',
						value: 'published'
					}]
				}],
			},
			{
				label: this.translate.instant('DRAFT'),
				value: 'draft',
				filterSet: [{
					filters: [{
						type: 'channel',
						field: 'status',
						operator: 'is',
						value: 'draft'
					}]
				}],
			}]
		};
	}

	ngOnInit() {
		this.bbTableService
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.subscriptions.add(this.authenticationService.hasPermission('put').subscribe(putRight => {
			this.putRight = putRight;
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
		super.ngOnDestroy();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['library/channel', row.data.id, 'general']);
		}
	}
}
